/**
 * @fileoverview PATCH handler for the "/engagement/campaigns/:app_group_id/:campaign_id/auto_stop_exemption" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { patchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionCacheKeys } from "./constants";
import type {
  PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionProps,
  PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResult,
  PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResultErrors,
} from "./types";

export const patchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemption = reactQueryMutationAdapter(
  patchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionCacheKeys,
  createMutationFetcherFunctionWithShadowError<PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResultErrors>()(
    ({
      appGroupId,
      campaignId,
      neverAutoStop,
      activeChangelogId,
    }: PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionProps): Promise<PatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResult> => {
      return fetch(
        `/engagement/campaigns/${appGroupId}/${campaignId}/auto_stop_exemption`,
        "PATCH",
        { never_auto_stop: neverAutoStop, active_changelog_id: activeChangelogId ?? "" },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
